export function incrementAdder(index: number, audioArray: any[]) {
  const arr = [];
  const amount = audioArray.length % 3 === 0 ? audioArray.length / 3 : 1;
  for (let i = 0; i < amount; i++) {
    arr.push(audioArray[i * 3 + index]);
  }
  return arr;
}
